<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card card-custom gutter-b">
        <!--begin::Header-->
        <div class="card-header border-0 pt-5">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label font-weight-bolder text-dark">
              Exibindo 2 Contagens (Total de 2)
            </span>
            <span class="text-muted mt-3 font-weight-bold font-size-sm">
              Acompanhe em tempo real todos as contagens cadastradas pelo seu estabelecimento
            </span>
          </h3>
          <div class="card-toolbar">
            <div class="input-icon h-40px">
              <input
                type="text"
                class="form-control form-control-lg form-control-solid h-40px"
                v-model="buscar"
                placeholder="Buscar..."
              />
              <span>
                <span class="svg-icon svg-icon-lg">
                  <!--begin::Svg Icon-->
                  <inline-svg src="media/svg/icons/General/Search.svg" />
                  <!--end::Svg Icon-->
                </span>
              </span>
            </div>
          </div>
        </div>
        <!--end::Header-->
        <!--begin::Body-->
        <div
          @scroll="handleScroll"
          class="card-body pt-2 pb-0"
          style="max-height: 418px; overflow-y: auto; overflow-x: auto"
        >
          <!--begin::Table-->
          <div class="table-responsive" style="overflow-x: initial">
            <b-table striped hover :items="items" :fields="fields">
            </b-table>
          </div>
          <!--end::Table-->
        </div>
        <!--end::Body-->
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapGetters } from "vuex";

export default {
  name: "Contagens",
  data() {
    return {
      buscar: "", 
      items: [
        {
          DATA: '21/02/2022',
          CODIGO: '1',
          SIGLA: 'AV1',
          DESCRICAO: 'Avaliação',
          LOCAL_ESTOQUE: 'Almoxarifado',
          TAXA_SUCESSO: '87%'
        },
        {
          DATA: '22/02/2022',
          CODIGO: '2',
          SIGLA: 'AV2',
          DESCRICAO: 'Avaliação 2',
          LOCAL_ESTOQUE: 'Almoxarifado',
          TAXA_SUCESSO: '100%'
        }
      ],
      fields: [
        {
          key: 'DATA',
          label: 'Data',
          sortable: true
        },
        {
          key: 'CODIGO',
          label: 'Código',
          sortable: true
        },
        {
          key: 'SIGLA',
          label: 'Sigla',
          sortable: true
        },
        {
          key: 'DESCRICAO',
          label: 'Descrição',
          sortable: true
        },
        {
          key: 'LOCAL_ESTOQUE',
          label: 'Local de Estoque',
          sortable: true
        },
        {
          key: 'TAXA_SUCESSO',
          label: 'Taxa de Sucesso',
          sortable: true
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Stock", route: "contagens" },
      { title: "Contagens" }
    ]);
  },
  computed: {
    ...mapGetters(["verificado", "fgModoPR"])
  },
  methods: {
    handleScroll() {

    }
  }
};
</script>
